import React, { useMemo } from 'react';
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { useTheme } from '../contexts/ThemeContext';

const MuiThemeWrapper = ({ children }) => {
  const { theme: themeMode } = useTheme();

  const theme = useMemo(() => {
    const isDark = themeMode === 'dark';

    return createTheme({
      palette: {
        mode: themeMode,
        primary: {
          main: '#667eea',
          light: '#8b9cf0',
          dark: '#4c5fc4',
          contrastText: '#ffffff',
        },
        secondary: {
          main: '#764ba2',
          light: '#9b6ec1',
          dark: '#5a3580',
          contrastText: '#ffffff',
        },
        background: {
          default: isDark ? '#0f1019' : '#f5f5fa',
          paper: isDark ? '#181a27' : '#ffffff',
        },
        text: {
          primary: isDark ? '#e8eaf0' : '#1a1a2e',
          secondary: isDark ? '#8b8fa8' : '#6b7280',
        },
        divider: isDark ? 'rgba(102, 126, 234, 0.15)' : 'rgba(102, 126, 234, 0.12)',
        error: {
          main: '#ef4444',
        },
        success: {
          main: '#10b981',
        },
      },
      typography: {
        fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
        h6: {
          fontWeight: 600,
        },
        body2: {
          fontWeight: 400,
        },
        caption: {
          color: isDark ? '#8b8fa8' : '#6b7280',
        },
      },
      components: {
        MuiCssBaseline: {
          styleOverrides: {
            body: {
              backgroundColor: isDark ? '#0f1019' : '#f5f5fa',
              color: isDark ? '#e8eaf0' : '#1a1a2e',
            },
          },
        },
      },
    });
  }, [themeMode]);

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};

export default MuiThemeWrapper;
